import { render, staticRenderFns } from "./button-group-one.mpx?vue&type=template&id=4e16d66c&isComponent&outputPath=components%2Fbutton-group-one5b029cb3%2Findex"
import script from "./button-group-one.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fbutton-group-one5b029cb3%2Findex"
export * from "./button-group-one.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fbutton-group-one5b029cb3%2Findex"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports